import { render, staticRenderFns } from "./PartCommandList.vue?vue&type=template&id=2bc96e5d&scoped=true"
import script from "./PartCommandList.vue?vue&type=script&lang=js"
export * from "./PartCommandList.vue?vue&type=script&lang=js"
import style0 from "./PartCommandList.vue?vue&type=style&index=0&id=2bc96e5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc96e5d",
  null
  
)

export default component.exports